module.exports = __webpack_public_path__ + "static/media/person.20777b47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person.svg
// module id = 98
// module chunks = 0